import { CommonListQuery, ProductCategory, UploadFileResponse } from "../../redux/api/apiTypes"
import { User } from "../common/types/types"

export const StartStatus = {
    // Trạng thái đấu giá
    UPCOMING: 1,    // Sắp diễn ra
    ONGOING: 2,     // Đang diễn ra
    PAUSE: 3,       // Tạm dừng
    FINISH: 4       // Kết thúc
}

export enum WebsocketTypes {
    TRA_GIA = "TRA_GIA",
    RUT_LAI_GIA = "RUT_LAI_GIA",
    TU_CHOI_GIA_TRUNG = "TU_CHOI_GIA_TRUNG",
    XAC_NHAN_GIA_TRUNG = "XAC_NHAN_GIA_TRUNG",
    TRUAT_QUYEN = "JOB_TU_DONG_TRUAT_QUYEN_KO_TRA_GIA",
    DGV_TRUAT_QUYEN = "DGV_TRUAT_QUYEN",
    ONLINE = "ONLINE",
    OFFLINE = "OFFLINE",
    PAUSE_PRODUCT_STATUTE = "PAUSE_PRODUCT_STATUTE",
    PRODUCT_STATUS = "PRODUCT_STATUS",
    IS_LATE = "IS_LATE",
    CHAP_NHAN_TRUNG = "CHAP_NHAN_TRUNG",
}

export enum WebsocketDestination {
    ADD_USER = "/app/bargain.addUser", // User bắt đầu vào tham gia đấu giá
}


export const BidderAcceptBidStatus = {
    DONE: 1,        // Đã trả giá
    SUCCESS: 2,     // Thành công
    FAILED: 3,       // Không thành công
    PAUSE: 4,       // Tạm dừng
    ACCEPT: 5,      // Chấp nhận giá khi đặt giá xuống
}

export interface AuctionSearch extends CommonListQuery {
    categoryCode?: string,
    fromDate?: string,
    productCode?: string,
    productName?: string,
    startPriceBegin?: number,
    startPriceTo?: number,
    startStatus?: number,
    status?: number,
    statuteId?: number,
    toDate?: string,
    type?: number,
    searchByUserLogin?: boolean,
    categoryCodes?: string[],
    startStatusList?: number[],
}

export interface AuctionList {
    content: AuctionResponse[],
    totalElements: number,
}

export interface AuctionResponse extends Product {
    // statute: Partial<StatuteItem>,
    bidderAcceptBid?: BidderAcceptBid,
    bidderResponseDTO?: BidderResponseDTO,
    registerStatus: number,
    timeRefusebargainFirt?: number,
    vbAttachmentImages?: UploadFileResponse[],
}

export interface BidderAcceptBid {
    bidderAcceptBidId?: number,
    isDelete?: number,
    status?: number,
    user?: User,
    valueOfBid?: number,
    createdDate?: number,
    modifiedDate?: number,
}

export interface BidderResponseDTO {
    auctionStatus: number,
    auctionStatusStr: string,
    bidderId: number,
    filesStr: string,
    identityCode: string,
    isActive: number,
    isDelete: number,
    note: string,
    preCostStatus: number,
    preCostStatusStr: string,
    registerStatus: number,
    registerStatusStr: string,
    status: 1,
}

export interface StatuteItem {
    statuteId: number,
    code: string,
    isDeleted?: number,
    status?: number,
    contractId?: number,
    contractCode?: string,
    incrementInTimePerBid?: number,
    startRegistrationDate: number,
    endRegistrationDate?: number,
    startPrePaymentDate: number,
    endPrePaymentDate?: number,
    bidRule?: number,
    allowWithdrawPaid?: number,
    isPublic?: number
    operator?: User
    totalRound?: number,
    startDate: number,
    endDate: number,
    sellerName: string,
    auctionType?: AuctionType,
    auctionMethod?: AuctionMethod,
    timePerPriceDown?: number,
    timePerProduct?: number,
    note1?: string,
    products?: Product[],
    type?: number,
    publicProgressAuction?: number,
    note?: string,
    address?: string,
    notePaused?: string,
}

export interface AuctionMethod {
    id: number,
    status: number,
    code: string,
    name: string,
    isDelete: number,
    actionTypeName: string,
    actionTypeCode: string,
    modifiedDate: number,
    modifiedDate_str: string,
    createdBy: string,
    createdDate: number,
    modifiedBy: string,
}

export interface AuctionType {
    status: number,
    code: string,
    name: string,
    type: number,
    isDelete: number,
    modifiedDate: number,
    modifiedDate_str: string,
    createdBy: string,
    createdDate: number,
    modifiedBy: string,
    id: number,
}

export interface Product {
    createdDate: number,
    createdDateStr: string,
    modifiedDate: number,
    createdBy: string,
    modifiedBy: string,
    productId: number,
    productName: string,
    productCode: string,
    description: string,
    productType: number,
    categories: ProductCategory[],
    startPrice: number,
    biddingCostPerBid: number,
    preCost: number,
    anotherCost: number,
    addressHasProperty: string,
    seller: User,
    isDelete: number,
    status: number,
    startPricePercent: number,
    feeForFailed: number,
    startAuctionDate: number,
    startAuctionDateStr: string,
    endAuctionDate: number,
    startStatus: number,
    startStatusStr: string,
    biddingDownPerTurn: number,
    minPrice: number,
    isCare: number,
    statute: StatuteItem,
    prePaymentStatus: number,
    statusContract?: number,
    statusContractStr?: string,
    views: number,
    viewcares: number,
    note?: string,
}

export interface BargainProductItem {
    createdDate: number,
    modifiedDate: number,
    createdBy: string,
    modifiedBy: string,
    user: User,
    product: Product,
    valueOfBid?: number,
    statusBidderAccept?: string,
    pbidderBidRegistrationId?: number,
    level?: number,
    bidder?: BidderDetail,
}

export interface AllBargainProductList {
    content: BargainProductItem[],
    totalElements: number
}

export interface BidderDetailList {
    content: BidderDetail[],
    totalElements: number,
}

export interface BidderDetail {
    auctionStatus: number,
    bidderId: number,
    createdBy: string,
    createdDate: number,
    isDelete: number,
    modifiedDate: number,
    preCostStatus: 0,
    product: Product,
    registerStatus: number,
    status: number,
    user: User,
    valueOfBid?: number,
    note: string,
    identityCode: string,
    noteDetect?: string,
    onlineStatus?: boolean,
}

export interface BidBargainProduct {
    code?: string,
    productId: number,
    valueOfBid?: number,
}

export interface CheckBargainProduct {
    levels: number[],
    productId: number,
    userId: number,
}

export interface GroupBargainSearch extends CommonListQuery {
    lstLevel: number[],
    productId: number,
}

export interface GroupBargainList {
    content: GroupBargainResponse[],
    totalElements: number,
}

export interface GroupBargainResponse {
    level: number,
    productId: Product,
    userId: User,
    valueOfBid: number,
}